/**
 * @generated SignedSource<<5539b768be915780c3b809c1b6a7ef44>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaymentActiveITP_charge$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ITPButton_charge" | "PaymentActiveITPDetails_charge" | "PaymentActiveITPValue_charge" | "PaymentLinkActiveCashbackFidelityBalance_charge" | "PaymentLinkActiveEarnCashbackFidelity_charge" | "PaymentLinkActiveEarnCashback_charge" | "PaymentLinkActiveEarnDiscount_charge" | "PaymentLinkAdditionalInfo_charge" | "PaymentLinkComment_charge" | "PaymentLinkPaymentTerm_charge">;
  readonly " $fragmentType": "PaymentActiveITP_charge";
};
export type PaymentActiveITP_charge$key = {
  readonly " $data"?: PaymentActiveITP_charge$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentActiveITP_charge">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaymentActiveITP_charge",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentActiveITPValue_charge"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentLinkComment_charge"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentLinkActiveEarnDiscount_charge"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentLinkActiveEarnCashback_charge"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentLinkActiveCashbackFidelityBalance_charge"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentLinkActiveEarnCashbackFidelity_charge"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ITPButton_charge"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentLinkPaymentTerm_charge"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentActiveITPDetails_charge"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentLinkAdditionalInfo_charge"
    }
  ],
  "type": "Charge",
  "abstractKey": null
};

(node as any).hash = "4164f3dab56adb0033d10705b5dbab6f";

export default node;
